<template>
	<div class="content-wrap" id="voiceSceneTeacherDetail">
		<div class="top">
			<div  class="btn-box">
				<div v-if="preId!=null"><a  @click="toPre(preId)">上一通练习</a></div>
				<div  v-if="preId==null"><a class="isgrey" >上一通练习</a></div>
			
				<div  v-if="nextId!=null"><a @click="toNext(nextId)">下一通练习</a></div>
				<div  v-if="nextId==null"><a class="isgrey">下一通练习</a></div>
				
				
			</div>
		</div>
    <div class="bottom">
  		<div class="content">
					  <!--评分结果-->
						<h3>{{existAdvise ? '练习得分与建议' : '练习得分'}}</h3>
		  			<!-- <audio :src="videoUrl" controls="controls"></audio> -->
					  <div class="video ivideo">
    				<span>练习录音</span>
						<audio :src="videoUrl" controls="controls"></audio>
					</div>
						<h3 class="practice">
							练习评分({{gradeScore}})
						</h3>
						<el-table :data="gradeList" :span-method="objectSpanMethod"  :header-cell-style="rowClass" :cell-class-name='addClass' border style="width: 100%;">
				      <el-table-column  label="练习内容"  align="center" >
						  	  <el-table-column prop="parentname"  width="110" align="center"></el-table-column>
									  <el-table-column prop="name" width="150" align="center"></el-table-column>

					  </el-table-column>
				      <!-- <el-table-column prop="name" label="二级内容" width="150" align="center"></el-table-column> -->
					    <el-table-column prop="gradeScore" label="总分" width="80" align="center">

						</el-table-column>
				      <el-table-column label="自评分" align="center" >
						    <el-table-column  label="扣分"  align="center" width="auto">
								<template slot-scope="scope">
									<el-tooltip placement="top">
									<div class="textstyle text-style">
                                       <span class="DeductPoints" v-if="scope.row.gradeScore-scope.row.score!=0">-{{scope.row.gradeScore-scope.row.score}}</span>
						               <span class="DeductionDetails">({{scope.row.checkedName}})</span>
						            </div>
									<div slot="content">{{scope.row.checkedName}}</div>
                              <!-- {{ scope.row.score-scope.row.gradeScore}} -->
                                    </el-tooltip>
                    </template>
							</el-table-column>
                <el-table-column  prop="score" label="得分" width="80" align="center" >

				</el-table-column>


				      </el-table-column>
					    <!-- <el-table-column prop="checkedName" label="点评"  align="center"></el-table-column> -->
					    <el-table-column v-if="existAdvise" label="练习建议" align="center">

							 <template slot-scope="scope">
                             <el-tooltip placement="top">
									  <div class="text-style">
									<span class="isred">{{ scope.row.description }}</span>
									  </div>
									  <div slot="content">{{ scope.row.description }}</div>
							 </el-tooltip>
                              <!-- {{ scope.row.score-scope.row.gradeScore}} -->
							  

                    </template>
				      <!-- <el-table-column v-if="existAdvise" label="系统建议" align="center">
				          <el-table-column label="建议" align="center">

                            <font c <template slot-scope="scope">olor="red">
                              {{ scope.row.description }}
                             </font>
                    </template>
				          </el-table-column> -->
                </el-table-column>
				    </el-table>
  		</div>
  	</div>
</div>
</template>
<script>
	export default {
		data() {
			return {
				id: this.$route.query.id,
				kf: this.$route.query.kf,
				callId: '',
				videoUrl: '', //录音文件
				gradeState: '', //评分状态
				effectStatus: null, //是否有效
				effectReason: '', //无效原因
				gradeScore: '', //得分
				gradeList: [], //点评内容
				evaluateList: [], //练习建议
				preId: '', //上一条记录
				nextId: '', //下一条记录
				keyData: 0, //更新页面
				spanArr: [],
				pos: 0,
                existAdvise : false ,//是否显示 系统建议
				Totalscore:0

			}
		},
		created() {
console.log(this.preId=='','28')
		},
		mounted() {
			this.queryGrade();
			

		},
		methods: {
			extractTotalscore(){
				


			},
   //更改某一列样式
    addClass({row,column,rowIndex,columnIndex}){ 
       if(columnIndex==3){  //此判断为第四列
          return 'addBorderStyle_3'
        }
		 if(columnIndex==4){  //此判断为第五列
          return 'addBorderStyle_4'
        }
    },


  // 合并表头
  rowClass({ row, column,rowIndex,columnIndex}) {
	  
        if(rowIndex===0 && columnIndex===0) {
          this.$nextTick(()=> {
            if(document.getElementsByClassName(column.id).length!==0) {
              document.getElementsByClassName(column.id)[0].setAttribute('rowSpan',2);
              return false
            }
          })
        }
        if(rowIndex===1 && (columnIndex===0 || columnIndex===1)) {
          return {display:'none'}
        }
		
		if(columnIndex==3 && rowIndex==0 ){
			return 'background-color:#f9dbd0 !important '
		}else if(columnIndex==3 && rowIndex==1){
			return 'background-color:#cbd5fa !important'
		}
		 if(columnIndex==2  ){
			return 'background-color:#cbd5fa !important'
		}
       
      },
			getSpanArr(data) {
				this.spanArr = [];
				this.pos = 0;
				for (var i = 0; i < data.length; i++) {
					if(i === 0) {
						// 如果是第一条记录（即索引是0的时候），向数组中加入１
						this.spanArr.push(1);
						this.pos = 0;
					}else {
						if(data[i].parentname=== data[i - 1].parentname) {
							// 如果name相等就累加，并且push 0 （这里的判断视自己的判定依据改变,name就是要对比的字段）
							this.spanArr[this.pos] += 1;
							this.spanArr.push(0);
						}else {
							// 不相等push 1
							this.spanArr.push(1);
							this.pos = i;
						}
					}
				}
			},
			objectSpanMethod({ row, column, rowIndex, columnIndex }) {
				// 用于设置要合并的列 0 表示第一列
				if (columnIndex === 0) {
					const cRow = this.spanArr[rowIndex];
					const cCol = cRow > 0 ? 1 : 0;
					return {
						rowspan: cRow, // 合并的行数
						colspan: cCol // 合并的列数，为0表示不显示
					}
				}
			},

			//查询评分字段
			queryGrade() {
				let self = this;
				let data = {
					'id': this.id,
					'kf': this.kf
				}
				var regex1 = /(?<=\()(.+?)(?=\))/g;
				this.$http.post(API_ROOT.college + '/voiceExerciseRecord/queryDetail', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.callId = result.data.callId;
						this.videoUrl = result.data.videoUrl;
						this.gradeState = result.data.gradeState;
						this.effectStatus = result.data.effectStatus;
						this.effectReason = result.data.effectReason;
						this.gradeScore = result.data.gradeScore;
						this.preId = result.data.preId;
						this.nextId = result.data.nextId;
						
						this.evaluateList = [];
						if(result.data.evaluateList) {
							result.data.evaluateList.map((item) => {
								this.evaluateList.push({'evaluate': item});
							})
						}else {
							this.evaluateList.push({'evaluate': ''});
						}
						this.gradeList = [];
						const teacherGradeMap = new Map();
						if(result.data.teacherGradeList != null) {
						  result.data.teacherGradeList.map((item) => {
                item.childList.map((obj) => {
                  let checkedId = '';
                  let checkedName = '';
                  obj.childList.map((o) => {
                    if(o.checked) {
                      checkedId = o.id;
                    }
                  })

                  let tempObj = {
                    'score': obj.gradeScore,
                    'childList': obj.childList,
                    'checkedId': checkedId
                  }
                  teacherGradeMap.set(obj.id, tempObj);
                })
              })
						}else if(result.data.gradeList != null){
              result.data.gradeList.map((item) => {
                item.childList.map((obj) => {
                  let checkedId = '';
                  let checkedName = '';
                  let tempObj = {
                    'childList': obj.childList,
                    'checkedId': checkedId
                  }
                  teacherGradeMap.set(obj.id, tempObj);
                })
              })

						}
						if(result.data.gradeList != null) {
							result.data.gradeList.map((item) => {
								item.childList.map((obj) => {
									let checkedId = '';
									let checkedName = '';
									let description = '';
									obj.childList.map((o) => {
										if(o.checked) {
											checkedId = o.id;
											checkedName = o.name;
											description = o.description;
										}
									})
									let teacherGradeObj = teacherGradeMap.get(obj.id);
								
									let tempObj = {
										'parentname': item.name,
										'name': obj.name,
										'score': obj.gradeScore,//总分
										'gradeScore':obj.score,//得分
										'childList': obj.childList,
										'checkedId': checkedId,
										'checkedName': checkedName,
										'description': description,
										'teacherGrade': teacherGradeObj ? teacherGradeObj : {},
										'Totalscore':obj.name.match(regex1)

									}
									console.log(obj.name.match(regex1),666)
									self.gradeList.push(tempObj);
								

                                    //判断是否有建议，无建议，则不显示“系统建议”那一列
                                    if(this.existAdvise == false && description/* != null && description.trim() != ''*/){
                                        this.existAdvise = true;
                                    }
								})
							})
						}
						this.getSpanArr(this.gradeList);
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			toPre(id) {
				window.location.href = '/tjkStudy/train/eachRecordDetail?id=' + id+'&kf='+this.kf
			},
			toNext(id) {
				window.location.href = '/tjkStudy/train/eachRecordDetail?id=' + id+'&kf='+this.kf
			},
			addEvaluate() {
				this.evaluateList.push({'evaluate': ''});
			},
			delEvaluate(key) {
				this.evaluateList.splice(key, 1);
			},
			//提交评分
			saveScore() {
				let choiceRuleIds = [],
						evaluateList = [];


        for(let i=0;i<this.gradeList.length;i++) {
          if(!this.gradeList[i].teacherGrade.checkedId) {
            this.$alert('练习点评为必选');
            return false;
            break;
          }else {
            choiceRuleIds.push(this.gradeList[i].teacherGrade.checkedId);
          }
        }
        for(let i=0;i<this.evaluateList.length;i++) {
          if(!this.evaluateList[i].evaluate) {
            this.$alert('请填写练习建议');
            return false;
            break;
          }else {
            evaluateList.push(this.evaluateList[i].evaluate);
          }
        }


				let data = {
					'id': this.id,
					'callId': this.callId,
					'choiceRuleIds': choiceRuleIds,
					'evaluateList': evaluateList
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseTeacher/savePartnerGrade', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.$alert('保存成功');
						this.queryGrade();
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//点击二级菜单
			clickSecond(index, key) {
				this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
				this.keyData+=1;
			}
		}
	}
</script>

<style lang="less">
#voiceSceneTeacherDetail {
  width: 100%;
  color: #262626;
  height:auto;
  padding-bottom:100px;
  .top {
    background-color: #D5D5D5;
    height: 104px;
    .btn-box {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      height: 100%;
      > div {
        width: 50%;
        text-align: left;
        &:last-child {
          text-align: right;
        }
        > a {
          display: inline-block;
          background-color: #497AF2;
          color: #fff;
          border-radius: 6px;
          width: 100px;
          height: 28px;
          line-height: 28px;
          text-align: center;
        }
      }
    }
  }
  .bottom {
    width: 1000px;
    height: auto;
    margin: 20px auto;
    background: #fff;
    box-shadow: 2px -2px 14px #999999;
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      height: auto;
      padding: 10px;
      font-size: 14px;
      .box {
      	text-align: left;
      	width: 100%;
      }
      .text-box {
      	text-align: center;
      }
      > p {
        margin-bottom: 5px;
      }
      .wuxiao {
        color: #F23B3F;
        width: 300px;
        text-align: center;
      }
      > h3 {
      	text-align: left;
      	font-size: 16px;
      	width: 100%;
      }
      .row {
      	width: 100%;
      	display: flex;
        align-items: center;
        margin-bottom: 5px;
        .el-input__inner {
          height: 36px;
        }
        > span {
          width: 60px;
          height: 32px;
          display: inline-block;
          color: #fff;
          text-align: center;
          line-height: 32px;
          background: #F57174;
          margin: 0 10px;
          border-radius: 6px;
          padding: 0 10px;
          cursor: pointer;
        }
      }
      .btn-save {
      	width: 100%;
      	text-align: center;
      	margin: 10px 0;
      }
      audio {
        height: 36px;
        width: 100%;
      }
    }
  }
}
.DeductPoints{color: red;font-weight: 600;width:auto;}
.isred{color: red;}

.DeductionDetails{color:#d3d3d3;}

.textstyle{text-align: left;}
.text-style{text-overflow: ellipsis;
	white-space: nowrap;overflow: hidden;}
.addBorderStyle_3{border-left: solid 2px #acb9e0 !important;

}
.addBorderStyle_4{border-right: solid 2px #acb9e0 !important;}
.text-style{text-overflow: ellipsis;
	white-space: nowrap;}
.isgrey{background: #8d9199 !important;}
</style>



// WEBPACK FOOTER //
// ./src/page/train/record/eachRecordDetail.vue